const readSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    rows: 1,
    slidesPerRow: 1,
    responsive: [
        {
            breakpoint: 1520,
            settings: {
                slidesToShow: 1,
            }
        },

        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 1
            }
        },


    ]

};

export default readSettings;